import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  GridsterComponent,
  GridsterItemComponent,
  GridsterConfig,
  GridType,
  DisplayGrid,
} from 'angular-gridster2';
import { CommonModule } from '@angular/common';
import { GridsterWidgetItem } from 'src/app/core/providers/dashboardWidget/dashboardWidget.models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-gridster-widgets',
  standalone: true,
  imports: [
    CommonModule,
    GridsterComponent,
    GridsterItemComponent,
    TranslateModule,
  ],
  templateUrl: './gridster-widgets.component.html',
  styleUrl: './gridster-widgets.component.scss',
})
export class GridsterWidgetsComponent implements OnChanges {
  @Input() widgets: GridsterWidgetItem[] = []; // Liste des widgets à afficher sur le tableau de bord
  @Input() options: GridsterConfig = {
    gridType: GridType.Fit, // type de grille, ici Fit permet de redimensionner les widgets pour remplir l'espace disponible
    displayGrid: DisplayGrid.Always, // affiche ou masque la grille, utile pour visualiser la disposition des widgets
    draggable: { enabled: true }, // active le drag and drop des widgets
    resizable: { enabled: true }, // active le redimensionnement des widgets
    pushItems: true, // permet de pousser les widgets existants lors du déplacement ou redimensionnement. Évite les collisions lors de déplacement.
    swap: true, // permet d'échanger la position de deux widgets lors du déplacement
    minCols: 4, // nombre minimum de colonnes dans la grille
    minRows: 4, // nombre minimum de lignes dans la grille
  };

  constructor(private translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['widgets'] && !changes['widgets'].firstChange) {
      this.widgets = [...this.widgets];
    }
  }
}
